import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Expired = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "72",
      cy: "72",
      r: "54",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M118 72C118 97.4051 97.4051 118 72 118C46.5949 118 26 97.4051 26 72C26 46.5949 46.5949 26 72 26C97.4051 26 118 46.5949 118 72Z",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M72 114C95.196 114 114 95.196 114 72C114 48.804 95.196 30 72 30C48.804 30 30 48.804 30 72C30 95.196 48.804 114 72 114ZM72 118C97.4051 118 118 97.4051 118 72C118 46.5949 97.4051 26 72 26C46.5949 26 26 46.5949 26 72C26 97.4051 46.5949 118 72 118Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M74 41H70V71.2L50.5517 91.6207L53.4483 94.3793L74 72.8V41Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M72 78C75.3137 78 78 75.3137 78 72C78 68.6863 75.3137 66 72 66C68.6863 66 66 68.6863 66 72C66 75.3137 68.6863 78 72 78Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
      fill: colors.illustration.critical
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M116 33V18H112V33H116ZM117 39C117 40.6569 115.657 42 114 42C112.343 42 111 40.6569 111 39C111 37.3431 112.343 36 114 36C115.657 36 117 37.3431 117 39Z",
      fill: colors.illustration.bg
    })]
  });
};
//# sourceMappingURL=Expired.js.map